import { render, staticRenderFns } from "./BetslipAreaB.vue?vue&type=template&id=3d7260de&scoped=true"
import script from "./BetslipAreaB.vue?vue&type=script&lang=js"
export * from "./BetslipAreaB.vue?vue&type=script&lang=js"
import style0 from "./BetslipAreaB.vue?vue&type=style&index=0&id=3d7260de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7260de",
  null
  
)

export default component.exports